<template>
  <v-chip class="pl-2 pr-2" label size="x-small"
          :variant="!currentDikeProfile || item.id !== currentDikeProfile.id ? 'outlined' : 'flat'"
          :style="`border: 1px solid ${item.properties.color};`"
          :color="item.properties.color"
          :disabled="disabled"
          @click.stop="flyTo(); setCurrentItem(item);"
          @dblclick.stop="setCurrentItem(null);"
  >
    {{ name ? item.properties.name : 'Profile' }}
  </v-chip>
</template>
<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {useEventsBus} from '@haskoning/vue-component-library'

const {emit} = useEventsBus()

export default {
  name: 'ProfileChip',
  props: {
    item: {},
    name: {required: false, default: false},
    disabled: {required: false, default: false}
  },
  computed: {
    ...mapGetters(
        {
          offset: 'dikeProfiles/getOffset',
        },
    ),
    ...mapState('dikeProfiles', {
      currentDikeProfile: state => state.currentItem,
    }),
  },
  methods: {
    flyTo(){
      emit('fly-to-dike-profile', this.item)
    },
    ...mapActions('dikeProfiles', {
          setCurrentItem: "setCurrentItem",
        }
    ),
  }
}
</script>
